import { BufferGeometry, Material, Mesh, Vector3 } from 'three';
import { autoInjectable } from 'tsyringe';
import { Body, Sphere, Vec3, World } from 'cannon-es';
import Resources from '../../Resources';
import Time from '../../Utils/Time';
import Renderer from '../Renderer';

@autoInjectable()
export class VrMesh extends Mesh {
    public vrUpdateLoop: any;
    public debug: boolean = true;
    public updateEvent: any;
    public physicsBody?: Body;
    public hasPhysics: boolean = false;
    public world?: World;

    public constructor(
        geometry?: BufferGeometry,
        material?: Material | Material[],
        public resources?: Resources,
        public time?: Time,
        public renderer?: Renderer,
    ) {
        super(geometry, material);

        // Sprawdź czy time istnieje przed użyciem
        if (this.time) {
            this.updateEvent = this.time.on('tick', () => this.update(this.time));
        }

        // Sprawdź czy renderer istnieje przed użyciem
        if (this.renderer?.webGLRenderer?.xr) {
            this.renderer.webGLRenderer.xr.addEventListener('sessionstart', (event) => {
                this.xrSessionStart(event);
                if (this.time) {
                    this.vrUpdateLoop = this.time.on('tick', () => this.xrUpdate(this.time));
                }
            });

            this.renderer.webGLRenderer.xr.addEventListener('sessionend', (event) => {
                if (this.vrUpdateLoop && this.time) {
                    this.time.remove(this.vrUpdateLoop);
                }
                this.xrSessionEnd(event);
            });
        }
    }

    public initPhysics(world: World, bodyOptions?: any): void {
        if (!world) {
            console.warn('Physics world not provided');
            return;
        }

        this.world = world;
        this.hasPhysics = true;

        const defaultOptions = {
            mass: 1,
            position: new Vec3(this.position.x, this.position.y, this.position.z),
            shape: new Sphere(0.5),
        };

        const options = { ...defaultOptions, ...bodyOptions };
        this.physicsBody = new Body(options);

        world.addBody(this.physicsBody);
    }

    public applyImpulse(impulse: Vector3, point?: Vector3): void {
        if (!this.hasPhysics || !this.physicsBody) return;

        const cannonImpulse = new Vec3(impulse.x, impulse.y, impulse.z);
        const cannonPoint = point ? new Vec3(point.x, point.y, point.z) : undefined;

        this.physicsBody.applyImpulse(cannonImpulse, cannonPoint);
    }

    public applyForce(force: Vector3, point?: Vector3): void {
        if (!this.hasPhysics || !this.physicsBody) return;

        const cannonForce = new Vec3(force.x, force.y, force.z);
        const cannonPoint = point ? new Vec3(point.x, point.y, point.z) : undefined;

        this.physicsBody.applyForce(cannonForce, cannonPoint);
    }

    public syncWithPhysics(): void {
        if (!this.hasPhysics || !this.physicsBody) return;

        this.position.copy(this.physicsBody.position as any);
        this.quaternion.copy(this.physicsBody.quaternion as any);
    }

    public update(_time?: Time): void {
        this.syncWithPhysics();
    }

    public updateChilder(_time: Time): void {}

    public destroy() {
        if (this.time && this.updateEvent) {
            this.time.remove(this.updateEvent);
        }
    }

    public xrUpdate(_time?: Time): void {}
    public xrSessionStart(_event): void {}
    public xrSessionEnd(_event): void {}
}
